(function () {
  const currentTarget = document.querySelector("#scroll-sentinel");
  const selector = ".floatable";

  console.log("scroll.js");

  const scrollCallback = (entries) => {
    const entry = entries[0];
    if (!entry) return;

    const isVisible = entry.isIntersecting;
    console.log({ isVisible });
    // onScrolled?.(isVisible);

    if (selector) {
      document
        .querySelectorAll(selector)
        .forEach((ele) => ele.classList.toggle("floating", !isVisible));
    }
  };

  let timeoutId = setTimeout(() => {
    observer = new IntersectionObserver(scrollCallback, {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    });

    observer.observe(currentTarget);
  }, 100); // 100ms is usually the sweet spot for layout stability
})();
